import store from "fragments/vendors/store"
import { gql } from "graphql-tag"

const UPDATE_STORE = gql`
  ${store}

  mutation updateStore($id: ID!, $storeUpdateInput: StoreUpdateInput!) {
    updateStore(id: $id, storeUpdateInput: $storeUpdateInput) {
      ...Store
    }
  }
`

export default UPDATE_STORE
